<template>
  <div class="w3-container" style="margin:0px;padding:0px">
    <h4 class="w3-center">{{ nearyby_stations.title }}</h4>

    <p>{{ nearyby_stations.guide }}</p>

    <!--    class="w3-bar-item w3-button tablink"
    <button onclick="myFunction('Demo1')"  ">
-->
    <div class="w3-bar">
      <div
        v-for="(direction, page_index) in nearyby_stations.directions"
        :key="page_index"
      >
        <!-- button -->
        <button style="  border-style: solid;  border-width: 1px;"
          class="w3-button w3-block w3-light-grey w3-left-align"
          :class="status[page_index] ? 'active_page' : 'not_active_page'"
          @click="toggle_status(page_index)"
        >
          <p class="w3-center">
            <strong>{{ direction.from }}</strong>
          </p>
        </button>

        <!--        :class="status[page_index] ? 'w3-show' : 'w3-hide'"-->
        <!-- tab contents -->
        <div
          class="w3-container w3-border room w3-animate-zoom"
          :class="status[page_index] ? 'w3-show' : 'w3-hide'"
        >
          <h3>{{ direction.id }}</h3>
          <p
            style="font-size: small; margin: 0px; padding: 0px"
            v-for="des in direction.by[0].des"
            :key="des"
          >
            {{ des }}
          </p>
          <img style="margin:5px 0px 5px 0px;" :src="direction.photo" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, computed } from "vue";
import { language_util } from "@/classes/language/language_util.js";
import { access } from "@/classes/access/access.js";
export default {
  components: {},
  setup() {
    const status = ref([false, false]);

    const nearyby_stations = computed(() =>
      access.get_nearby_station_info(language.value)
    );
    const language = computed(() => {
      return language_util.get_language();
    });
    function toggle_status(index) {
      if (index == 0) {
        status.value[0] = !status.value[0];
        //if (status.value[0]) status.value[1] = false;
      } else {
        status.value[1] = !status.value[1];
        //if (status.value[1]) status.value[0] = false;
      }
    }

    return {
      status,
      toggle_status,
      nearyby_stations,
      //openStation,
      //current_station,
    };
  },
};
</script>

<style scoped>
.active {
  color: red;
}

img {
  max-width: 100%;
  height: auto;
}

.blockClass {
  display: block;
}

.noneClass {
  display: none;
}
.active_page {
  background-color: red;
  color: white;
}
.not_active_page {
  background-color: black;
  color: white;
}

p {
  margin: 0px;
  padding: 1px;
}
</style>